import { useEffect } from 'react'
import { setUser } from '@sentry/nextjs'
import { useFreshSession } from 'blocks/auth/useFreshSession'

export function SentryUserManager() {
    const { data: session } = useFreshSession()

    useEffect(() => {
        if (session) {
            const user = session.user
            setUser({
                email: user.email,
                username: user.name,
                id: user.id,
                companyId: user.companyId,
            })
        }
    }, [session])

    return null
}
